/*eslint no-shadow:0*/
// Ignore no-shadow as this file will eventually get replaced by the new datepicker
define('glu/datepicker/dateRangePicker',['require','../$','../date','bootstrap-daterangepicker'],function(require) {
    'use strict';
    var root = (typeof window !== 'undefined') ? window : this;
    var $ = require('../$') || root.Glu.$;
    var moment = require('../date');

    require('bootstrap-daterangepicker');

    /**
     * --------------------------------------------------------------------
     * jQuery-Plugin "daterangepicker.jQuery.js"
     * by Scott Jehl, scott@filamentgroup.com
     * reference article: http://www.filamentgroup.com/lab/update_date_range_picker_with_jquery_ui/
     * demo page: http://www.filamentgroup.com/examples/daterangepicker/
     *
     * Copyright (c) 2010 Filament Group, Inc
     * Dual licensed under the MIT (filamentgroup.com/examples/mit-license.txt) and GPL (filamentgroup.com/examples/gpl-license.txt) licenses.
     *
     * Dependencies: jquery, jquery UI datepicker, date.js -> moment.js, jQuery UI CSS Framework

     * 12.15.2010 Made some fixes to resolve breaking changes introduced by jQuery UI 1.8.7
     * --------------------------------------------------------------------
     */
    $.fn.daterangepicker = function(settings) {
        var rangeInput = $(this);

        //defaults
        var options = $.extend({
            presetRanges: [{
                    text: 'Today',
                    dateStart: 'today',
                    dateEnd: 'today'
                }, {
                    text: 'Last 7 days',
                    dateStart: function() {
                        return moment().subtract(7, 'days').toDate();
                    },
                    dateEnd: 'today'
                }, {
                    text: 'Last 30 Days',
                    dateStart: function() {
                        return moment().subtract(30, 'days').toDate();
                    },
                    dateEnd: 'today'
                }, {
                    text: 'Last 60 Days',
                    dateStart: function() {
                        return moment().subtract(60, 'days').toDate();
                    },
                    dateEnd: 'today'
                }, {
                    text: 'Last 90 Days',
                    dateStart: function() {
                        return moment().subtract(90, 'days').toDate();
                    },
                    dateEnd: 'today'
                }, {
                    text: 'Month to date',
                    dateStart: function() {
                        return moment().startOf('month').toDate();
                    },
                    dateEnd: 'today'
                }, {
                    text: 'Quarter to date',
                    dateStart: function() {
                        return moment().startOf('quarter').toDate();
                    },
                    dateEnd: 'today'
                }, {
                    text: 'Year to date',
                    dateStart: function() {
                        var x = moment().toDate();
                        x.setMonth(0);
                        x.setDate(1);
                        return x;
                    },
                    dateEnd: 'today'
                }

                //{text: 'Tomorrow', dateStart: 'Tomorrow', dateEnd: 'Tomorrow' },
                //{text: 'Ad Campaign', dateStart: '03/07/08', dateEnd: 'Today' },
                //{text: 'Last 30 Days', dateStart: 'Today-30', dateEnd: 'Today' },
                //{text: 'Next 30 Days', dateStart: 'Today', dateEnd: 'Today+30' },
                //{text: 'Our Ad Campaign', dateStart: '03/07/08', dateEnd: '07/08/08' }
            ],
            //presetRanges: array of objects for each menu preset.
            //Each obj must have text, dateStart, dateEnd. dateStart, dateEnd accept date.js string or a function which returns a date object
            presets: {
                specificDate: 'Specific Date',
                recurringDate: 'Recurring Date',
                allDatesBefore: 'All Dates Before',
                allDatesAfter: 'All Dates After',
                dateRange: 'Date Range'
            },
            rangeStartTitle: 'Start date',
            rangeEndTitle: 'End date',
            nextLinkText: '', //'Next'
            prevLinkText: '', //'Prev'
            target: rangeInput,
            doneButtonText: 'Done',
            earliestDate: moment().subtract(15, 'year').toDate(), //earliest date allowed
            latestDate: moment().add(15, 'year').toDate(), //latest date allowed
            constrainDates: false,
            rangeSplitter: '-', //string to use between dates in single input
            dateFormat: 'm/d/yy', // date formatting. Available formats: http://docs.jquery.com/UI/Datepicker/%24.datepicker.formatDate
            closeOnSelect: true, //if a complete selection is made, close the menu
            arrows: false,
            appendTo: 'body',
            onClose: function() {},
            onOpen: function() {},
            onChange: function() {},
            datepickerOptions: null //object containing native UI datepicker API options
        }, settings);


        //build picker and
        var rp = $('<div class="ui-daterangepicker ui-widget ui-helper-clearfix ui-widget-content ui-corner-all"></div>');

        //function to format a date string

        function fDate(date) {
            if (!date.getDate()) {
                return '';
            }
            var day = date.getDate();
            var month = date.getMonth();
            var year = date.getFullYear();
            month++; // adjust javascript month
            var dateFormat = options.dateFormat;
            return $.datepicker.formatDate(dateFormat, date);
        }

        function hideRP(focus) {
            var focusState;

            if (focus === undefined) {
                focusState = true;
            } else {
                focusState = focus;
            }
            if (rp.data('state') === 'open') {
                rp.fadeOut(300).data('state', 'closed');

                if (focusState) {
                    rangeInput.focus();
                }
                options.onClose();
            }
        }

        /**
         * Function to set the min/max to null - this is called when dates should not be constrained.
         * Only dates using the date range selection feature should have a constrained range
         */
        function resetMinMax(rp) {
            rp.find('.range-end').datepicker('option', 'minDate', null);
            rp.find('.range-start').datepicker('option', 'maxDate', null);
        }

        //custom datepicker options, extended by options
        var datepickerOptions = {
            onSelect: function(dateText, inst) {
                var rangeStart = rp.find('.range-start');
                var rangeEnd = rp.find('.range-end');


                if (rp.find('.ui-daterangepicker-specificDate').is('.ui-state-active')) {
                    rangeEnd.datepicker('setDate', rangeStart.datepicker('getDate'));
                }

                if (rp.find('.ui-daterangepicker-recurringDate').is('.ui-state-active')) {
                    rangeEnd.datepicker('setDate', rangeStart.datepicker('getDate'));
                }

                $(this).trigger('constrainOtherPicker');

                var rangeA = fDate(rangeStart.datepicker('getDate'));
                var rangeB = fDate(rangeEnd.datepicker('getDate'));

                //send back to input or inputs
                if (rangeInput.length === 2) {
                    rangeInput.eq(0).val(rangeA);
                    rangeInput.eq(1).val(rangeB);
                } else {
                    rangeInput.val((options.rangePicker && (rangeA !== rangeB)) ? rangeA + ' ' + options.rangeSplitter + ' ' + rangeB : rangeA);
                }
                //if closeOnSelect is true
                if (options.closeOnSelect) {
                    if (!rp.find('li.ui-state-active').is('.ui-daterangepicker-dateRange') && !rp.is(':animated')) {
                        hideRP();
                    }

                    $(this).trigger('constrainOtherPicker');

                    options.onChange();
                }
            },
            onChangeMonthYear: function() {
                var settingsChange = arguments[2],
                    $calendar = $(this).parents('.ui-daterangepickercontain'),
                    $input = $calendar.siblings('.input-date');

                if (settingsChange.currentMonth !== settingsChange.selectedMonth || settingsChange.currentYear !== settingsChange.selectedYear) {
                    setTimeout(function() {
                        var firstActiveDay = $calendar.find('.ui-datepicker-calendar td[data-handler="selectDay"]').eq(0);

                        firstActiveDay.find('a').focus();
                    }, 200);
                } else {
                    $input.focus();
                }

            },
            defaultDate: +0
        };

        //change event fires both when a calendar is updated or a change event on the input is triggered
        rangeInput.bind('change', options.onChange);

        //datepicker options from options
        options.datepickerOptions = (settings) ? $.extend(datepickerOptions, settings.datepickerOptions) : datepickerOptions;

        //Capture Dates from input(s)
        var inputDateA, inputDateB = moment().toDate();
        var inputDateAtemp, inputDateBtemp;
        if (rangeInput.size() === 2) {
            inputDateAtemp = moment(rangeInput.eq(0).val()).toDate();
            inputDateBtemp = moment(rangeInput.eq(1).val()).toDate();
            if (inputDateAtemp === null) {
                inputDateAtemp = inputDateBtemp;
            }
            if (inputDateBtemp === null) {
                inputDateBtemp = inputDateAtemp;
            }
        } else {
            inputDateAtemp = moment(rangeInput.val().split(options.rangeSplitter)[0]).toDate();
            inputDateBtemp = moment(rangeInput.val().split(options.rangeSplitter)[1]).toDate();
            if (inputDateBtemp === null) {
                inputDateBtemp = inputDateAtemp;
            } //if one date, set both
        }
        if (inputDateAtemp !== null) {
            inputDateA = inputDateAtemp;
        }
        if (inputDateBtemp !== null) {
            inputDateB = inputDateBtemp;
        }

        //preset menu click events

        function clickActions(el, rp, $rpPickers, doneBtn) {

            if (el.is('.ui-daterangepicker-specificDate')) {
                //Specific Date (show the "start" calendar)
                // Determine animation speed (prevents display oddities since we are bypassing the range drop down)
                var anim = $('.no-range-select').find(rp).length > 0 ? 0 : 400;
                // Open specific date picker				
                resetMinMax(rp);
                doneBtn.hide();
                $rpPickers.show();
                rp.find('.title-start').text(options.presets.specificDate);
                rp.find('.range-start').restoreDateFromData().css('opacity', 1).show(anim);
                rp.find('.range-end').restoreDateFromData().css('opacity', 0).hide(anim);
                if (!options.closeOnSelect || anim > 0) {
                    setTimeout(function() {
                        doneBtn.fadeIn();
                    }, 400);
                }
            } else if (el.is('.ui-daterangepicker-recurringDate')) {
                resetMinMax(rp);
                doneBtn.hide();
                $rpPickers.show();
                rp.find('.title-start').text(options.presets.recurringDate);
                rp.find('.range-start').restoreDateFromData().css('opacity', 1).show(400);
                rp.find('.range-end').restoreDateFromData().css('opacity', 0).hide(400);
                setTimeout(function() {
                    doneBtn.fadeIn();
                }, 400);
            } else if (el.is('.ui-daterangepicker-allDatesBefore')) {
                //All dates before specific date (show the "end" calendar and set the "start" calendar to the earliest date)
                resetMinMax(rp);
                doneBtn.hide();
                $rpPickers.show();
                rp.find('.title-end').text(options.presets.allDatesBefore);
                rp.find('.range-start').saveDateToData().datepicker('setDate', options.earliestDate).css('opacity', 0).hide(400);
                rp.find('.range-end').restoreDateFromData().css('opacity', 1).show(400);
                setTimeout(function() {
                    doneBtn.fadeIn();
                }, 400);
            } else if (el.is('.ui-daterangepicker-allDatesAfter')) {
                //All dates after specific date (show the "start" calendar and set the "end" calendar to the latest date)
                resetMinMax(rp);
                doneBtn.hide();
                $rpPickers.show();
                rp.find('.title-start').text(options.presets.allDatesAfter);
                rp.find('.range-start').restoreDateFromData().css('opacity', 1).show(400);
                rp.find('.range-end').saveDateToData().datepicker('setDate', options.latestDate).css('opacity', 0).hide(400);
                setTimeout(function() {
                    doneBtn.fadeIn();
                }, 400);
            } else if (el.is('.ui-daterangepicker-dateRange')) {
                //Specific Date range (show both calendars)
                doneBtn.hide();
                $rpPickers.show();
                rp.find('.title-start').text(options.rangeStartTitle);
                rp.find('.title-end').text(options.rangeEndTitle);
                rp.find('.range-start').restoreDateFromData().css('opacity', 1).show(400);
                rp.find('.range-end').restoreDateFromData().css('opacity', 1).show(400);
                setTimeout(function() {
                    doneBtn.fadeIn();
                }, 400);
            } else {
                //custom date range specified in the options (no calendars shown)
                doneBtn.hide();
                rp.find('.range-start, .range-end').css('opacity', 0).hide(400, function() {
                    $rpPickers.hide();
                });
                var dateStart = (typeof el.data('dateStart') === 'string') ? moment(el.data('dateStart')).toDate() : el.data('dateStart')();
                var dateEnd = (typeof el.data('dateEnd') === 'string') ? moment(el.data('dateEnd')).toDate() : el.data('dateEnd')();
                resetMinMax(rp);
                rp.find('.range-start').datepicker('setDate', dateStart).find('.ui-datepicker-current-day').trigger('click');
                rp.find('.range-end').datepicker('setDate', dateEnd).find('.ui-datepicker-current-day').trigger('click');
                doneBtn.trigger('click');
            }

            return false;
        }



        //build picker and

        var rpPresets = ((function() {
            var ul = $('<ul class="ui-widget-content"></ul>').appendTo(rp);
            $.each(options.presetRanges, function() {
                $('<li class="ui-daterangepicker-' + this.text.replace(/ /g, '') + ' ui-corner-all"><a href="#">' + this.text + '</a></li>')
                    .data('dateStart', this.dateStart)
                    .data('dateEnd', this.dateEnd)
                    .appendTo(ul);
            });
            var x = 0;
            $.each(options.presets, function(key, value) {
                $('<li class="ui-daterangepicker-' + key + ' preset_' + x + ' ui-helper-clearfix ui-corner-all"><a href="#">' + value + '</a><span class="icon-arrow-right"></span></li>')
                    .appendTo(ul);
                x++;
            });

            ul.find('li').hover(
                    function() {
                        $(this).addClass('ui-state-hover');
                    },
                    function() {
                        $(this).removeClass('ui-state-hover');
                    })
                .click(function() {
                    rp.find('.ui-state-active').removeClass('ui-state-active');
                    $(this).addClass('ui-state-active');
                    clickActions($(this), rp, $rpPickers, doneBtn);
                    return false;
                });
            return ul;
        })());

        var $rpPickers = $('<div class="ranges ui-widget-header ui-corner-all ui-helper-clearfix"><div class="range-start"><span class="title-start">Start Date</span></div><div class="range-end"><span class="title-end">End Date</span></div></div>').appendTo(rp);
        var doneBtn = $('<button class="btnDone btn btn-primary">' + options.doneButtonText + '</button>')
            .click(function() {
                rp.find('.ui-datepicker-current-day').trigger('click');
                hideRP();
            })
            .appendTo($rpPickers);



        $.fn.restoreDateFromData = function() {
            if ($(this).data('saveDate')) {
                $(this).datepicker('setDate', $(this).data('saveDate')).removeData('saveDate');
            }
            return this;
        };

        $.fn.saveDateToData = function() {
            if (!$(this).data('saveDate')) {
                $(this).data('saveDate', $(this).datepicker('getDate'));
            }
            return this;
        };

        var riContain = (options.arrows && rangeInput.size() === 1) ? rangeInput.parent() : undefined;

        function positionRP() {

            var relEl = riContain || rangeInput; //if arrows, use parent for offsets
            var riOffset = relEl.offset(),
                side = 'left',
                val = riOffset.left,
                offRight = $(window).width() - val - relEl.outerWidth();

            if (val > offRight) {
                side = 'right';
                val = offRight;
            }

            rp.parent().css(side, val).css('top', riOffset.top + relEl.outerHeight());
        }

        //show, hide, or toggle rangepicker

        function showRP() {
            if (rp.data('state') === 'closed') {
                positionRP();
                rp.fadeIn(300).data('state', 'open');
                options.onOpen();
            }
        }

        function toggleRP() {
            if (rp.data('state') === 'open') {
                hideRP();
            } else {
                showRP();
            }
        }


        //picker divs
        $rpPickers.find('.range-start, .range-end').datepicker(options.datepickerOptions);


        $rpPickers.find('.range-start').datepicker('setDate', inputDateA);
        $rpPickers.find('.range-end').datepicker('setDate', inputDateB);

        $rpPickers.find('.range-start, .range-end')
            .bind('constrainOtherPicker', function() {
                if (options.constrainDates) {
                    //constrain dates
                    if ($(this).is('.range-start')) {
                        rp.find('.range-end').datepicker('option', 'minDate', $(this).datepicker('getDate'));
                        // Prevent a range from being shown in the text input in the specific date scenario
                        if (rp.find('.ui-daterangepicker-specificDate').is('.ui-state-active')) {
                            rp.find('.range-end').datepicker('option', 'maxDate', $(this).datepicker('getDate'));
                        }
                    } else {
                        rp.find('.range-start').datepicker('option', 'maxDate', $(this).datepicker('getDate'));
                    }
                }
            })
            .trigger('constrainOtherPicker');



        //inputs toggle rangepicker visibility
        $(this).click(function() {
            if ($('.no-range-select').find(this).length > 0) {
                rp.find('.ui-daterangepicker-specificDate').trigger('click');
            }
            toggleRP();
            return false;
        });

        $(this).parent().find('.ui-datepicker-trigger').click(function() {
            if ($('.no-range-select').find(this).length > 0) {
                rp.find('.ui-daterangepicker-specificDate').trigger('click');
            }
            toggleRP();
            return false;
        });

        //hide em all
        $rpPickers.hide().find('.range-start, .range-end, .btnDone').hide();

        rp.data('state', 'closed');

        //Fixed for jQuery UI 1.8.7 - Calendars are hidden otherwise!
        $rpPickers.find('.ui-datepicker').css('display', 'block');

        //inject rp
        $(options.appendTo).append(rp);

        //wrap and position
        rp.wrap('<div class="ui-daterangepickercontain"></div>');

        //add arrows (only available on one input)
        if (options.arrows && rangeInput.size() === 1) {
            var prevLink = $('<a href="#" class="ui-daterangepicker-prev ui-corner-all" title=""><span class="ui-icon ui-icon-circle-triangle-w"></span></a>');
            var nextLink = $('<a href="#" class="ui-daterangepicker-next ui-corner-all" title=""><span class="ui-icon ui-icon-circle-triangle-e"></span></a>');

            $(this)
                .addClass('ui-rangepicker-input ui-widget-content')
                .wrap('<div class="ui-daterangepicker-arrows ui-widget ui-widget-header ui-helper-clearfix ui-corner-all"></div>')
                .before(prevLink)
                .before(nextLink)
                .parent().find('a').click(function() {
                    var dateA = $rpPickers.find('.range-start').datepicker('getDate');
                    var dateB = $rpPickers.find('.range-end').datepicker('getDate');
                    var diff = Math.abs(new TimeSpan(dateA - dateB).getTotalMilliseconds()) + 86400000; //difference plus one day
                    if ($(this).is('.ui-daterangepicker-prev')) {
                        diff = -diff;
                    }

                    $rpPickers.find('.range-start, .range-end ').each(function() {
                        var thisDate = $(this).datepicker('getDate');
                        if (thisDate === null) {
                            return false;
                        }
                        $(this).datepicker('setDate', thisDate.add({
                            milliseconds: diff
                        })).find('.ui-datepicker-current-day').trigger('click');
                    });
                    return false;
                })
                .hover(
                    function() {
                        $(this).addClass('ui-state-hover');
                    },
                    function() {
                        $(this).removeClass('ui-state-hover');
                    });

            riContain = rangeInput.parent();
        }

        $(document).click(function() {
            if (rp.is(':visible')) {
                hideRP();
            }
        });

        /*Closing datepicker using only keyboard esc and closing it while navigating to the next fields*/
        $(document).on('keyup.' + options.datePickerId, function(e) {
            var inputFlag = $(e.target).is('input') && e.keyCode !== $.ui.keyCode.DOWN,
                selectFlag = $(e.target).is('select') && (e.target.className.indexOf('ui-datepicker-') === -1);

            if (e.keyCode === $.ui.keyCode.ESCAPE && rp.is(':visible')) {
                hideRP();
            }
            if (inputFlag || selectFlag && rp.is(':visible')) {
                hideRP(false);
            }
        });

        rp.click(function() {
            return false;
        }).hide();

        return this;
    };


});

